import ItemCliente from "../../models/ItemCliente";
import ItemUsuario from "../../models/ItemUsuario";
import { ApiServiceRequest, ApiServiceRequestDatos } from "./api.service.request";
import { IApiServiceResponse } from "./api.service.response";

export default abstract class ApiService {
    public static Login(usuario: string, contraseña: string) : Promise<ItemCliente[]> {
        return new Promise<ItemCliente[]>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "Login", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("", "", {
                    "ForzarSesion": true,
                }), usuario, contraseña)),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<ItemCliente[]>) => {
                        if (response.CodigoRespuesta === 12) {
                            resolve(response.Datos);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static SelectCustomer(usuario: string, contraseña: string, codigoCliente: string) : Promise<ItemUsuario> {
        return new Promise<ItemUsuario>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "Login", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("", "", {
                    "ForzarSesion": true,
                }), usuario, contraseña, codigoCliente)),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<ItemUsuario>) => {
                        if (response.CodigoRespuesta === 9) {
                            sessionStorage.removeItem('user');
                            window.location.reload();
                        }
                        else if (response.CodigoRespuesta === 1) {
                            resolve(response.Datos);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static Register(email: string, contraseña: string, nombre: string, espacio: string, prefijo: string, telefono: string) : Promise<string> {
        return new Promise<string>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "Registro", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("", "", {
                    "Nombre": nombre,
                    "Espacio": espacio,
                    "Prefijo": prefijo,
                    "Telefono": telefono,
                }), email, contraseña)),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<null>) => {
                        if (response.CodigoRespuesta === 1) {
                            resolve(response.Mensaje);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static ConfirmRegister(email: string, contraseña: string, token: string) : Promise<string> {
        return new Promise<string>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "RegistroConfirmar", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("", "", {
                    "TokenVerificacion": token,
                }), email, contraseña)),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<null>) => {
                        if (response.CodigoRespuesta === 1) {
                            resolve(response.Mensaje);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static ConfirmRegisterInvitation(email: string, contraseña: string, nombre: string, token: string) : Promise<string> {
        return new Promise<string>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "RegistroConfirmar", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("", "", {
                    "TokenVerificacion": token,
                    "Nombre": nombre,
                    "Pwd": contraseña,
                }), email, contraseña)),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<null>) => {
                        if (response.CodigoRespuesta === 1) {
                            resolve(response.Mensaje);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static Recover(email: string) : Promise<string> {
        return new Promise<string>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "Recuperar", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("", ""), email)),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<null>) => {
                        if (response.CodigoRespuesta === 1) {
                            resolve(response.Mensaje);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static ConfirmRecover(email: string, token: string) : Promise<string> {
        return new Promise<string>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "RecuperarConfirmar", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("", "", {
                    "TokenRecuperacion": token,
                }), email)),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<null>) => {
                        if (response.CodigoRespuesta === 1) {
                            resolve(response.Mensaje);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static ChangePasswordRecover(email: string, contrasena: string, token: string) : Promise<string> {
        return new Promise<string>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "RecuperarCambiar", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("", "", {
                    "TokenRecuperacion": token,
                }), email, contrasena)),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<null>) => {
                        if (response.CodigoRespuesta === 1) {
                            resolve(response.Mensaje);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static Token(input: any = {}) : Promise<IApiServiceResponse<any>> {
        return new Promise<IApiServiceResponse<string>>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "Token", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("Configuracion", "ExecToken", input), "", "", "", "")),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<any>) => {
                        if (response.CodigoRespuesta === 1) {
                            resolve(response);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static Post<T>(clase: string, metodo: string, user: ItemUsuario, input: any = {}, isPublic: boolean = false, android: boolean = false) : Promise<T> {
        return new Promise<T>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + "Cliente", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos(clase, metodo, input), user.IdUsuario, "", user.CodigoCliente, user.Token, android)),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<T>) => {
                        if (!isPublic && response.CodigoRespuesta === 9) {
                            sessionStorage.removeItem('user');
                            window.location.reload();
                        }
                        else if (response.CodigoRespuesta === 1) {
                            resolve(response.Datos);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };

    public static PostAnonym<T>(metodo: string, input: any = {}) : Promise<T> {
        return new Promise<T>((resolve, reject) => {
            fetch((process.env.REACT_APP_API_URL || "") + metodo, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(new ApiServiceRequest(new ApiServiceRequestDatos("", "", input), "", "", "", "")),
            }).then((response: Response) => {
                if (response.status === 200) {
                    response.json().then((response: IApiServiceResponse<T>) => {
                        if (response.CodigoRespuesta === 1) {
                            resolve(response.Datos);
                        }
                        else {
                            reject(response.Mensaje);
                        }
                    }, () => {
                        reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                    });
                }
                else {
                    reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                }
            }, () => {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            });
        });
    };
};
